import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolder2"><Path d="M2 9V3H10.4142L12.4142 5H22V9H2Z" fill="currentColor"/><Path d="M2 11V20H22V11H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder2;
